module.exports = __webpack_public_path__ + "static/img/govcard_07.1715020b.svg";